import { createContext, useContext } from 'react'

import { ChatMessageFrom, ChatMessageSize } from './types'

export type ChatMessageContextType = {
  from: ChatMessageFrom
  size: ChatMessageSize
  loading: boolean
}

export const ChatMessageContext = createContext<ChatMessageContextType>({
  from: 'other',
  size: 'md',
  loading: false,
})

export const useChatMessageContext = () => {
  const context = useContext(ChatMessageContext)
  if (!context) {
    throw new Error('ChatMessageContext not found')
  }
  return context
}
